import { preload } 		from './modules/mod_preload'
import { navigation } 	from './modules/mod_navigation'
import { slider } 		from './modules/mod_slider'
import { counter } 		from './modules/mod_counter'
import { hero } 		from './modules/mod_hero'
import { regionenBands } from './modules/mod_regionen_bands'
import { newswissenToc } from './modules/mod_newswissen_toc'
import { accordions } 	from './modules/mod_accordions'
import { webmVideos } 	from './modules/mod_webm_videos'

webmVideos()

window.onload = function () {
	preload()
	navigation()
	slider()
	counter()
	hero()
	regionenBands()
	newswissenToc()
	accordions()
}

